import { QueryHookOptions, useQuery } from "@apollo/client"
import { gql } from "../../../../../../../../gql"
import {
  AdditionalSalariesInfoQuery,
  AdditionalSalariesInfoQueryVariables,
} from "../../../../../../../../gql/graphql"

export const GET_ADDITIONAL_SALARIES_INFO = gql(`
  query AdditionalSalariesInfo($countryCode: String!, $subdivisionCodes: [String!]) {
    countryIntelligence(countryCode: $countryCode, subdivisionCodes: $subdivisionCodes) {
      additionalSalariesRules {
        customerInfoMessage
        customerInfoTitle
        salaries {
          arePaymentMonthsEditable
          canBeProrated
          defaultSelectedMonths
          isDefaultEnabled
          isEditable
          isPartOfGrossSalary
          maxSelectedMonths
          salary
        }
      }
    }
  }
`)

const useAdditionalSalariesInfo = (
  variables: AdditionalSalariesInfoQueryVariables,
  options: QueryHookOptions<AdditionalSalariesInfoQuery, AdditionalSalariesInfoQueryVariables> = {},
) => {
  const useQueryReturn = useQuery(GET_ADDITIONAL_SALARIES_INFO, { ...options, variables })

  const additionalSalariesRules = useQueryReturn.data?.countryIntelligence?.additionalSalariesRules
  const salary13th = additionalSalariesRules?.salaries?.find(rule => rule.salary === 13)
  const salary14th = additionalSalariesRules?.salaries?.find(rule => rule.salary === 14)

  return {
    ...useQueryReturn,
    additionalSalariesRules: { ...additionalSalariesRules, salary13th, salary14th },
  }
}

export default useAdditionalSalariesInfo
